import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  IconButton,
  Radio,
  ListItemSecondaryAction,
  Divider,
  Box,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/Close"; // Import close icon
import { useState } from "react";
import { CustomButton } from "../../../../components/CustomButton/CustomButton";
import { AsyncImage } from "loadable-image";

export const CategorySelectionModal = ({
  open,
  onClose,
  categories,
  onSelectCategory,
  parentCategory,
  selectedCategoryId,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
    id: parentCategory?.categoryId,
    categoryName: parentCategory?.categoryName,
  }); // State to store the selected category

  // Filter categories based on search term
  const filteredCategories = categories.filter((category) =>
    category.categoryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle category selection
  const handleCategorySelect = (category) => {
    console.log(category, "====>");
    setSelectedCategory(category);
  };

  // Handle "Select" button click
  const handleConfirmSelection = () => {
    if (selectedCategory) {
      onSelectCategory(selectedCategory); // Pass the selected category to the parent
      onClose(); // Close the modal
    }
  };

  console.log(filteredCategories, selectedCategoryId);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ padding: "0" }}
    >
      {/* Dialog Title with Close Icon */}
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Select Parent Category
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* Search Bar */}
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search categories or subcategories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton edge="start">
                  <SearchOutlinedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        {/* Divider between Search Bar and List */}
        <Divider sx={{ mb: 2 }} />

        {/* Category List (No Dividers between Items) */}
        <List>
          {filteredCategories.map((category) => {
            if (category?.id !== selectedCategoryId)
              return (
                <ListItem
                  button
                  key={category.id}
                  onClick={() => handleCategorySelect(category)}
                >
                  <div
                    style={{
                      display: "flex",
                      marginInlineEnd: "10px",
                      border: ".5px solid gray",
                      borderRadius: "4px",
                    }}
                  >
                    <AsyncImage
                      src={category?.images?.[0]}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <ListItemText
                    primary={category.categoryName}
                    secondary={`${
                      category?.productCount ?? category?.products?.length ?? 0
                    } product${
                      (category?.productCount ??
                        category?.products?.length ??
                        0) !== 1
                        ? "s"
                        : ""
                    }`}
                  />
                  {/* Radio Button */}
                  <ListItemSecondaryAction>
                    <Radio
                      edge="end"
                      checked={selectedCategory?.id === category.id}
                      onChange={() => handleCategorySelect(category)}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              );
          })}
        </List>

        {/* Divider between List and Select Button */}
        <Divider sx={{ mt: 2 }} />
      </DialogContent>

      {/* Centered Select Button */}
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <CustomButton
          onClick={handleConfirmSelection}
          disabled={!selectedCategory} // Disable if no category is selected
          variant="contained"
          color="primary"
          sx={{ width: "110px", textTransform: "unset" }} // Set a fixed width for the button
        >
          Select
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};
